import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-concrete-900 py-16 sm:py-24" aria-labelledby="faq" data-id="element-71" data-mp="1lbisipaq7vqv">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-72" data-mp="1l9fr7944ig6u">
        <h2 id="faq" className="font-display text-3xl uppercase leading-none text-concrete-50 sm:text-5xl" data-id="element-73" data-mp="1ge0gur5br2f6">
          Preguntas que tienen{' '}
          <span className="text-safety" data-id="element-74" data-mp="290tntr9b4xxm">los maistros</span>
        </h2>

        <ul className="mt-10 border-t border-concrete-700" data-id="element-75" data-mp="28zielbx3exz4">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <li key={item.q} className="border-b border-concrete-700" data-id="element-76" data-mp="1z2dvxm2ghkn2" data-mpi={i}>
                <h3 data-id="element-77" data-mp="snd5tx043woe">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-5 text-left font-display text-lg uppercase text-concrete-50 transition-colors duration-150 ease-out hover:text-safety sm:text-xl" data-id="element-78" data-mp="snwdmkw1t4op">
                    {item.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-safety transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-79" data-mp="ki1u7bwohua4" />
                  </button>
                </h3>
                {isOpen && <p id={`faq-panel-${i}`} className="pb-6 text-base leading-relaxed text-concrete-400 sm:text-lg" data-id="element-80" data-mp="3swtrgyzubcyd">
                    {item.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}